<template>
  <div>
    <h1>Unidade</h1>
    <v-container grid-list-md>
      <v-toolbar color="transparent" flat dense>
        <v-toolbar-items>
          <v-btn to="/branches" text><v-icon>view_list</v-icon></v-btn>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn v-if="this.id" color="error" text @click="confirmDeleteBranch"
            >Excluir</v-btn
          >
          <v-btn @click="saveBranch" text>Salvar</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-layout column>
        <v-flex md12 mt-3>
          <v-card>
            <v-layout px-4 pt-4 wrap>
              <v-flex md8>
                <v-text-field
                  id="name"
                  name="name"
                  label="Nome Fantasia"
                  v-model="branch.name"
                ></v-text-field>
              </v-flex>
              <v-flex md4>
                <v-text-field
                  id="taxId"
                  name="taxId"
                  label="CNPJ"
                  v-model="branch.taxId"
                ></v-text-field>
              </v-flex>
              <v-flex md12>
                <v-text-field
                  id="taxName"
                  name="taxName"
                  label="Razão Social"
                  v-model="branch.taxName"
                ></v-text-field>
              </v-flex>
              <v-flex md8>
                <v-text-field
                  id="email"
                  name="email"
                  label="e-mail"
                  v-model="branch.email"
                ></v-text-field>
              </v-flex>
              <v-flex md4>
                <v-checkbox
                  label="Comissionada"
                  v-model="branch.receivesCommission"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex md12 mt-3>
          <AddressCard :address="branch.address" />
        </v-flex>
        <v-flex md12 mt-3>
          <v-card>
            <v-layout px-4 pt-4 wrap>
              <v-flex md6>
                <v-text-field
                  id="smtpHost"
                  name="smtpHost"
                  label="Host SMTP"
                  v-model="branch.smtpHost"
                ></v-text-field>
              </v-flex>
              <v-flex md6>
                <v-text-field
                  id="smtpPort"
                  name="smtpPort"
                  label="Porta SMTP"
                  v-model="branch.smtpPort"
                ></v-text-field>
              </v-flex>
              <v-flex md6>
                <v-text-field
                  id="smtpUsername"
                  name="smtpUsername"
                  label="Usuário SMTP"
                  v-model="branch.smtpUsername"
                ></v-text-field>
              </v-flex>
              <v-flex md6>
                <v-text-field
                  id="smtpPassword"
                  name="smtpPassword"
                  label="Senha SMTP"
                  type="password"
                  v-model="branch.smtpPassword"
                ></v-text-field>
              </v-flex>
              <v-flex md4>
                <v-checkbox
                  label="SMTP com TLS"
                  v-model="branch.smtpRequiresSsl"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <OperationStatusCard
      id="loadingStatusCard"
      ref="loadingStatusCard"
      progressMessage="Carregando"
      successMessage="Pronto"
      errorMessage="Falha ao carregar"
    />
    <OperationStatusCard
      id="operationStatusCard"
      ref="operationStatusCard"
      progressMessage="Salvando"
      successMessage="Salvo com sucesso"
      errorMessage="Falha ao salvar"
    />
    <ConfirmDialog
      id="confirmDeleteDialog"
      ref="confirmDeleteDialog"
      title="Excluir Registro"
      :message="`Deseja realmente excluir a unidade ${this.branch.name}?`"
      yes-button="Sim"
      no-button="Não"
      @confirm="deleteBranch"
    />
  </div>
</template>
<script>
import api from "@/api";
import AddressCard from "@/components/Shared/AddressCard";
import ConfirmDialog from "@/components/Shared/ConfirmDialog";
import OperationStatusCard from "@/components/Shared/OperationStatusCard";
export default {
  name: "customer-form",
  components: {
    AddressCard,
    ConfirmDialog,
    OperationStatusCard
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  data() {
    return {
      branch: {
        address: {}
      }
    };
  },
  methods: {
    saveBranch() {
      this.$refs.operationStatusCard.show();
      var endpoint = this.id ? `/branches/${this.id}` : "/branches";
      var method = this.id ? "PUT" : "POST";
      api
        .request(method, endpoint, this.branch)
        .then(() => {
          this.$refs.operationStatusCard.succeed();
          this.$router.push("/branches");
        })
        .catch(error => {
          this.$refs.operationStatusCard.fail(error.response.data);
        });
    },
    confirmDeleteBranch() {
      this.$refs.confirmDeleteDialog.show();
    },
    deleteBranch() {
      this.$refs.operationStatusCard.show();
      api
        .request("DELETE", `/branches/${this.id}`, this.branch)
        .then(() => {
          this.$refs.operationStatusCard.succeed();
          this.$router.push("/branches");
        })
        .catch(error => {
          this.$refs.operationStatusCard.fail(error.response.data);
        });
    }
  },
  mounted() {
    if (this.id) {
      this.$refs.loadingStatusCard.show();
      api
        .request("GET", `/branches/${this.id}`)
        .then(response => {
          this.branch = response.data;
          this.$refs.loadingStatusCard.close();
        })
        .catch(error => {
          this.$refs.loadingStatusCard.fail(error.response.data);
        });
    }
  }
};
</script>
